<!-- PayPal donation button (user request, 18/10/2026): at the bottom of the computer sidebar and of the phone ☰ menu
     (`menu`; `compact`: only the icon, in the reduced sidebar), just above the divider before Search, in the main colour (it follows the colour chosen in Settings). Opens PayPal in a new tab; not shown while DONATE_URL (src/features/donate.ts) is empty. -->
<script setup lang="ts">
import { donateHref } from '../features/donate'
import { useI18n } from '../composables/useI18n'

defineProps<{ menu?: boolean; compact?: boolean }>()
const emit = defineEmits<{ open: [] }>()
const { t } = useI18n()
const href = donateHref()
</script>

<template>
  <a v-if="href" id="donateBtn" :href="href" target="_blank" rel="noopener" :title="t('Like Hideo? Support it with a donation')"
    :class="menu ? 'w-full flex items-center gap-3 px-3 py-2.5 font-semibold rounded-xl text-left text-brand bg-brand/10 hover:bg-brand/20'
      : compact ? 'hidden md:flex w-full items-center justify-center py-2.5 text-brand bg-brand/10 hover:bg-brand/20 rounded-xl transition-colors'
      : 'hidden md:flex w-full items-center space-x-3 px-4 py-2.5 text-brand bg-brand/10 hover:bg-brand/20 rounded-xl font-medium transition-colors'"
    @click="emit('open')">
    <i class="fa-brands fa-paypal text-center w-5"></i>
    <span v-if="!compact" :class="menu ? 'truncate' : 'text-sm font-semibold'">{{ t('Donate with PayPal') }}</span>
  </a>
</template>
